module.exports = __webpack_public_path__ + "img/dashboard-hei.00482cd8.svg";